"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _dompurify = _interopRequireDefault(require("dompurify"));
var _core = require("core.ui-module_site-components");
var _ApplicationContext = require("../../api/ApplicationContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class InitializeAuthenticationReset extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      errorMessage: ''
    };
  }
  componentDidMount() {
    this.setState({
      errorMessage: '',
      isLoading: true
    });
    this.props.listener(this, null);
  }
  render() {
    const {
      errorMessage,
      isLoading
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: `lds-spinner-overlay ${isLoading && 'is-active'}`
    }, isLoading && /*#__PURE__*/_react.default.createElement(_core.Spinner, null)), /*#__PURE__*/_react.default.createElement(_core.OkModal, {
      header: "Authentication Error",
      message: errorMessage,
      display: errorMessage !== '',
      key: errorMessage
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "login-box content"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title",
      dangerouslySetInnerHTML: {
        __html: _ApplicationContext.ApplicationContext.getLoginGreetingTitle() ? _dompurify.default.sanitize(_ApplicationContext.ApplicationContext.getLoginGreetingTitle()) : 'Welcome back'
      }
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "subtitle"
    }, _ApplicationContext.ApplicationContext.getLoginGreetingSubTitle() || `Log in to the ${_ApplicationContext.ApplicationContext.getSiteName()}`), /*#__PURE__*/_react.default.createElement("div", {
      className: "content"
    }, /*#__PURE__*/_react.default.createElement("form", {
      id: "loginForm",
      method: "post"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "field field-submit-button"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: "is-primary"
    }, "Log In")))))));
  }
}
InitializeAuthenticationReset.propTypes = {
  listener: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(InitializeAuthenticationReset);
//# sourceMappingURL=InitializeAuthenticationReset.js.map